var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeVessel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12780_100672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 17C28 10.9249 23.0751 6 17 6C10.9249 6 6 10.9249 6 17C6 23.0751 10.9249 28 17 28C23.0751 28 28 23.0751 28 17Z",
    fill: "#201E21"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.332 10.3335H16.332V11.8335H13.1653V15.237L11.0159 16.0431L13.4216 22.2292C13.3211 22.2744 13.1404 22.3237 12.8776 22.3659C12.6081 22.4092 12.2923 22.4392 11.9675 22.4595C11.3182 22.5001 10.6657 22.5002 10.332 22.5002V23.5002H10.3346C10.6685 23.5002 11.3476 23.5002 12.0298 23.4576C12.3716 23.4362 12.7226 23.4037 13.0363 23.3532C13.3383 23.3047 13.6511 23.233 13.8889 23.1141C14.0899 23.0136 14.3869 22.8462 14.7161 22.6607C14.8857 22.5651 15.0641 22.4645 15.2422 22.3659C16.3308 21.7631 17.6241 21.8025 18.8449 22.3111L20.8232 23.1354L20.8405 23.1412C21.2264 23.2698 21.7701 23.3575 22.2768 23.4138C22.7915 23.471 23.3102 23.5002 23.6653 23.5002V22.5002C23.3537 22.5002 22.8725 22.4738 22.3872 22.4199C21.9033 22.3662 21.4551 22.2891 21.1731 22.1979L20.937 22.0995L22.9587 16.0346L20.832 15.237V11.8335H17.332V10.3335ZM20.0115 21.7139L21.7053 16.6325L17.4987 15.055V20.9456C18.0898 21.0021 18.6746 21.1569 19.2295 21.388L20.0115 21.7139ZM16.4987 20.9474V15.055L12.3148 16.624L14.3058 21.7439C14.4478 21.6639 14.5992 21.5789 14.7578 21.4911C15.3147 21.1827 15.9031 21.0089 16.4987 20.9474ZM16.9987 13.7995L14.1653 14.862V12.8335H19.832V14.862L16.9987 13.7995Z",
    fill: "#D6610D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12780_100672",
    x: 1,
    y: 1,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0.752941 0 0 0 0 0.537255 0 0 0 0.72 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12780_100672"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12780_100672",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeVessel);
export default __webpack_public_path__ + "static/media/orangeVessel.64f338978917f5b2afdf13f9a9db9136.svg";
export { ForwardRef as ReactComponent };